module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAfBAMAAADzSTu5AAAAJFBMVEUAAABcXGZiYmlfX2NfX2heXmVeXmVeXmZeXmZeXmZeXmZeXmYWgobkAAAAC3RSTlMAGSc7O2Jv1OHm8tovQPoAAAA4SURBVBjTYxAVYICC6kkwVvdOBSjLajdMkGU1XNCL1oIwJ2XvDkAXg6tD6KWmEMK/iDBAhAs8rACeXyvXavvrxgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/notice/more.png
// module id = vGOZ
// module chunks = 1